import branchProfile from '@/api/corporate/branch-profile'

import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty } from 'lodash'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return branchProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return branchProfile.store(data)
  },
  update(context, { id, data }) {
    return branchProfile.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await branchProfile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return branchProfile.destroy(id)
  },
  upload(context, data) {
    return branchProfile.imageLogo(data)
  },
  getFormViewData() {
    return branchProfile.formModel()
  }
}
